import * as React from 'react';

import { TipsContext, TipsContextProps } from './context';

export const useTipsContext = (): TipsContextProps => {
  const context = React.useContext(TipsContext);
  if (!context) {
    throw new Error('useTipsContext must be used within a TipsProvider');
  }

  return context;
};
